import React, { useState } from "react";
import { Link } from "react-router-dom";

function ReturnOrder() {
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Fake generated order number
  const generatedOrder = `#${Math.floor(10000 + Math.random() * 90000)}`;

  const returnReasons = [
    "Printer not working on arrival",
    "Ink/Toner leaked during delivery",
    "Printer not compatible with my device",
    "Wrong product delivered",
    "Print quality issues (blurry, faded, banding)",
    "Item damaged or broken",
    "Missing parts or cables",
    "Ordered by mistake",
  ];

  const handleSubmit = () => {
    setSubmitted(true);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 300);
  };

  const sampleItem = {
    name: "HP DeskJet 4155e Wireless All-in-One Printer",
    quantity: 1,
    price: 129.99,
  };

  return (
    <div className="return-wrapper">
      <div className="container">
        <h2 className="title">Return Your Order</h2>

        {/* Step 1: Order Number Input */}
        {!showForm && !submitted && (
          <div className="input-card">
            <p>Please enter your order number to request a return.</p>

            <input className="input" placeholder="e.g. #48293" />

            <button className="th-btn" onClick={() => setShowForm(true)}>
              Continue
            </button>

            <Link className="link" to="/shop">
              ← Back to Shopping
            </Link>
          </div>
        )}

        {/* Step 2: Return Form */}
        {showForm && !submitted && (
          <div className="details-card">
            <h4>Order Found</h4>
            <p className="order-code">{generatedOrder}</p>

            <div className="summary">
              <strong>Product:</strong>
              <p>{sampleItem.name}</p>

              <div className="row-line">
                <span>Quantity:</span>
                <strong>{sampleItem.quantity}</strong>
              </div>

              <div className="row-line">
                <span>Price:</span>
                <strong>${sampleItem.price}</strong>
              </div>

              <div className="divider"></div>

              <label className="label">Select Reason for Return</label>
              <select className="input">
                {returnReasons.map((reason, i) => (
                  <option key={i} value={reason}>
                    {reason}
                  </option>
                ))}
              </select>

              <textarea
                className="input"
                placeholder="Additional comments (optional)"
                rows={4}
              />

              <button className="submit-btn" onClick={handleSubmit}>
                Submit Return Request
              </button>
            </div>

            <Link className="link" to="/shop">
              ← Cancel and Continue Shopping
            </Link>
          </div>
        )}

        {/* Step 3: Success Message */}
        {submitted && (
          <div className="success-box">
            <div className="icon">✔</div>
            <h3>Your Return Request Has Been Submitted</h3>
            <p>
              We’ve received your request for <strong>{generatedOrder}</strong>.
              Our team will review it and email you within 24–48 hours with next
              steps.
            </p>

            <div className="actions">
              <Link className="th-btn" to="/my-account">
                Go to My Account
              </Link>
              <Link
                className="th-btn style2"
                to="/shop"
                style={{ background: "black" }}
              >
                Continue Shopping
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* ==== Styling ==== */}
      <style>{`
        .return-wrapper{padding:60px 0;background:#f6f8fc;}
        .title{text-align:center;font-size:32px;font-weight:700;margin-bottom:30px;}

        .input-card, .details-card, .success-box{
          background:#fff;padding:25px;border-radius:14px;
          max-width:480px;margin:0 auto;text-align:center;
          box-shadow:0 6px 18px rgba(0,0,0,0.05);
        }

        .input{width:100%;padding:14px;border-radius:10px;
          border:1px solid #ccc;font-size:16px;margin-bottom:14px;
        }

        .input:focus{border-color:#0b61d6;outline:none;}

        .th-btn{
          background:#0b61d6;color:#fff;padding:14px 22px;
          border-radius:10px;font-weight:600;border:none;
          cursor:pointer;transition:.3s;
        }
        
        .style2{background:#fff;border:2px solid #0b61d6;color:#0b61d6;}
        

        .link{text-decoration:none;font-size:14px;margin-top:6px;
              display:block;color:#0b61d6;}

        .order-code{
          display:inline-block;background:#eaf6ff;padding:6px 16px;
          border-radius:10px;color:#0b61d6;font-size:20px;
          margin-bottom:15px;font-weight:700;
        }

        .summary{text-align:left;}
        .row-line{
          display:flex;justify-content:space-between;margin-bottom:6px;
          font-size:16px;
        }

        .label{display:block;font-weight:600;margin-top:12px;margin-bottom:6px;}

        .divider{border-bottom:1px solid #ddd;margin:10px 0;}

        .submit-btn{
          width:100%;padding:14px;background:#0b61d6;color:#fff;
          border-radius:10px;margin-top:12px;font-size:16px;
          font-weight:600;border:none;cursor:pointer;
        }

        .success-box{text-align:center;padding:35px;}
        .success-box .icon{
          width:80px;height:80px;border-radius:50%;
          background:#31c653;color:white;font-size:45px;
          display:flex;align-items:center;justify-content:center;
          margin:0 auto 18px;
        }

        .actions{display:flex;gap:12px;justify-content:center;margin-top:20px;}
      `}</style>
    </div>
  );
}

export default ReturnOrder;
